<template>
  <tr>
    <td colspan="3" class="text-left">
      <div class="confection-inputs">
        <basic-input
          validationRule="required|max:50"
          name="confection-split-criteria"
          labelClass="mb-2"
          label="Sposób podziału zamówienia"
          description="Opisz w jaki sposób mamy przygotować dla Ciebie podpaczki"
          placeholder="np. według działów, według lokalizacji"
          inputType="text"
          v-model="splitCriteria"
        />
      </div>
    </td>
  </tr>
</template>


<script>
import { mapFields } from 'vuex-map-fields';
import BasicInput from '../Inputs/basicInput.vue';

export default {
  name: 'NDEConfectionSplitCriteriaForm',
  components: {
    BasicInput,
  },
  computed: {
    ...mapFields('confection', ['splitCriteria']),
  },
};
</script>
